__turbopack_context__.v({
  "actions": "GraphContext-module-scss-module__e6AE4G__actions",
  "detailedDescriptionLabel": "GraphContext-module-scss-module__e6AE4G__detailedDescriptionLabel",
  "tableButton": "GraphContext-module-scss-module__e6AE4G__tableButton",
  "wrapper": "GraphContext-module-scss-module__e6AE4G__wrapper",
});
